import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Wrappers, ErrorCard } from '../components';

const NotFound = () => (
  <Wrappers.Layout>
    <ErrorCard
      title={
        <FormattedMessage
          id="title.notfound"
          description="404 page title"
          defaultMessage="Not Found"
        />
      }
      description={
        <FormattedMessage
          id="description.notfound"
          description="404 page description"
          defaultMessage="Like a grain of wheat in a bin of barley, that page can't be found"
        />
      }
    />
  </Wrappers.Layout>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound.js